import { useEffect } from 'preact/hooks'
import { useAthosContext } from '../fetchers/provider'
import { SearchPageLink } from './SearchPageLink'
import { useNormaliseSuggestions } from '../hooks/useNormaliseSuggestions'

export function QuickSearchSuggestions({ query, type }) {
  const { results, refine } = useAthosContext()
  const normalisedResults = useNormaliseSuggestions(results)
  const parser = new DOMParser()

  useEffect(() => {
    if (query) {
      refine('query', query)
    }
  }, [query])

  if (!normalisedResults || normalisedResults?.length === 0) return null

  return (
    <div className="flex flex-col items-start w-full gap-2">
      {normalisedResults?.map((result) => (
        <SearchPageLink type={type} key={result.query} query={result.query} className="font-medium underline whitespace-normal transition-colors duration-150 underline-offset-4 hover:text-primary-blue">
          {parser.parseFromString(result.label, 'text/html').body.textContent}
        </SearchPageLink>
      ))}
    </div>
  )
}
